/** @jsx jsx */
import { jsx } from '@emotion/core';
import NumberFormat from 'react-number-format';
import colors from '../../css/colors';
import Button from '../ui/Button';
import { PencilIcon, TrashCanIcon } from '../ui/icons';
import CopyIconComponent from 'components/ui/CopyIconComponent';
import ToolTip from 'components/ui/ToolTip';

export default function Contact({
  id,
  firstName,
  lastName,
  email,
  phone,
  ext,
  defaultContact,
  defaultTaxContinContact,
  defaultTitleContinContact,
  isEditable,
  handleEditContact,
  handleDeleteContact,
  isClientModal,
}) {
  const outerWrap = {
    backgroundColor: colors.greyOrder,
    borderRadius: 5,
    margin: '0 16px 8px 16px',
    padding: isEditable ? '16px 24px' : '16px 30px',
    width: isEditable ? 495 : 'calc(100% - 20px)',
  };

  const deleteContact = async () => {
    handleDeleteContact(id);
  };
  const editContact = async () => {
    handleEditContact(id);
  };
  const defaultContactLabels = [
    defaultContact && 'Default Contact',
    defaultTaxContinContact && 'Default Tax Contin Contact',
    defaultTitleContinContact && 'Default Title Contin Contact',
  ].filter(Boolean);

  return (
    <div css={{ backgroundColor: 'white' }}>
      <div
        css={{
          ...outerWrap,
          margin: isEditable ? '8px 0px' : '8px auto',
          maxWidth: isEditable ? 495 : '100%',
          position: 'relative',
        }}
      >
        <div>
          <span css={{ fontWeight: 'bold' }}>
            {firstName} {lastName}
          </span>
        </div>
        {defaultContactLabels.length > 0 && (
          <div
            css={{
              display: 'flex',
              flexWrap: 'wrap',
              alignItems: 'flex-start',
              gap: 6,
              marginTop: 10,
              '& > span': {
                backgroundColor: '#e9e9ee',
                color: '#565660',
                borderRadius: 4,
                padding: '3px 9px',
                fontSize: 12,
                fontWeight: 500,
                lineHeight: '18px',
              },
            }}
          >
            {defaultContactLabels.map(label => (
              <span key={label}>{label}</span>
            ))}
          </div>
        )}
        <div
          css={{
            display: 'flex',
            justifyContent: 'space-between',
            paddingTop: 16,
          }}
        >
          <div css={{ color: colors.greyDark }}>
            {isClientModal && (
              <ToolTip
                toolTipText="Copy email address"
                displayContents={true}
                toolTipOverrides={{ position: 'absolute', top: -45, left: 305 }}
              >
                <CopyIconComponent
                  style={{
                    cursor: 'pointer',
                  }}
                  textToCopy={email}
                />
              </ToolTip>
            )}
            {email}
          </div>
          <div>
            <div css={{ color: colors.blackText }}>
              <NumberFormat value={phone} displayType={'text'} format="###-###-####" mask="_" />
            </div>
            {ext && <div css={{ color: colors.blackText, marginLeft: 16 }}>Ext {ext}</div>}
          </div>
          {isEditable && (
            <span
              css={{
                position: 'absolute',
                top: 16,
                right: 24,
                display: 'flex',
                alignItems: 'center',
                gap: 24,
                '& > button': {
                  display: 'flex',
                  padding: 6,
                  margin: -6,
                  border: 0,
                  borderRadius: 6,
                  backgroundColor: 'transparent',
                  color: colors.redLight,
                  cursor: 'pointer',
                  transition: 'background-color 150ms ease',
                  '&:hover': { backgroundColor: 'rgba(255, 82, 82, 0.12)' },
                },
              }}
            >
              <button type="button" aria-label="Edit contact" onClick={editContact}>
                <PencilIcon width={22} height={22} />
              </button>
              <button type="button" aria-label="Delete contact" onClick={deleteContact}>
                <TrashCanIcon width={20.4} height={21.6} />
              </button>
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
